import { ModuleWithProviders, NgModule } from '@angular/core';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BlockUIModule } from 'primeng/blockui';
import { AutoFocusModule } from 'primeng/autofocus';
import { PaginatorModule } from 'primeng/paginator';
import { OrderListModule } from 'primeng/orderlist';
import { CarouselModule } from 'primeng/carousel';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

const PRIME_NG_MODULES = [
  OrderListModule,
  AutoFocusModule,
  ScrollPanelModule,
  ButtonModule,
  ToastModule,
  TabViewModule,
  RippleModule,
  PanelModule,
  CardModule,
  ChipModule,
  InputTextModule,
  InputTextareaModule,
  InputNumberModule,
  CalendarModule,
  DropdownModule,
  AutoCompleteModule,
  TableModule,
  RatingModule,
  ProgressBarModule,
  MultiSelectModule,
  EditorModule,
  ConfirmPopupModule,
  CheckboxModule,
  ChipsModule,
  OverlayPanelModule,
  BadgeModule,
  SplitButtonModule,
  DividerModule,
  TooltipModule,
  AvatarModule,
  AvatarGroupModule,
  TagModule,
  ListboxModule,
  ScrollTopModule,
  MenuModule,
  PanelMenuModule,
  ConfirmDialogModule,
  SidebarModule,
  DialogModule,
  ProgressSpinnerModule,
  AccordionModule,
  ContextMenuModule,
  RadioButtonModule,
  StepsModule,
  SelectButtonModule,
  InputSwitchModule,
  BlockUIModule,
  PaginatorModule,
  CarouselModule,
  DynamicDialogModule,
  MessageModule,
  MessagesModule,
  DragDropModule,
  PasswordModule,
];

@NgModule({
  imports: [PRIME_NG_MODULES],
  exports: [PRIME_NG_MODULES],
})
export class PrimeNGModule {
  public static forRoot(): ModuleWithProviders<PrimeNGModule> {
    return {
      ngModule: PrimeNGModule,
    };
  }
}
